






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Notification extends Vue {
  @Prop({ default: false }) showNotifications!: boolean;

  @Prop() text!: string;

  @Prop() type!: string;
}
